require('../../modules/es6.number.is-nan');
module.exports = require('../../modules/_core').Number.isNaN;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/is-nan.js
// module id = 211
// module chunks = 4220841425358 102538987983895